export const POST_LOGIN = "token/";
export const POST_SIGN_UP = "/client/signup/";
export const POST_RESEND_OTP = "/client/resend/";
export const POST_INITIATE_RESET_PASSWORD = "/reset-password/";
export const POST_RESET_PASSWORD = "/reset-password/confirm/";
export const GET_CLIENT_DASHBOARD = "/client/dashboard/?survey_id={surveyId}";
export const GET_GOALS = "client/goals/?domain={domainId}&survey_id={surveyId}";
export const GET_QUESTION_BY_ID =
  "/client/question/?goal_id={goalId}&survey_id={surveyId}";
export const POST_SUBMIT_QUESTION_BY_ID = "/client/question/?id={id}";
export const GET_GOALS_STATUS =
  "/client/goal-statuses/?domain={domainId}&survey_id={surveyId}";
export const POST_REFRESH_TOKEN = "/token/refresh/";
export const GET_MIL_DATA =
  "/client/progress-graph/?domain={domainId}&survey_id={surveyId}";
export const GET_PRACTICES_DATA =
  "/client/practices-chart/?domain={domainId}&survey_id={surveyId}";
export const GET_AUDIT_TRAIL =
  "/client/audit-trail/?survey_id={surveyId}&question_id={qnId}";
export const POST_CREATE_SURVEY = "/admin/start-survey/";
export const GET_SURVEYS_LIST =
  "/admin/survey-list/?search={searchItem}&filter={filterItem}";
export const GET_USER_DETAILS = "/client/user/";
export const POST_APPROVE_SURVEY = "/admin/approve/";
export const POST_REJECT_SURVEY = "/admin/reject/";
export const ARCHIVE_SURVEY = "/admin/archive/";
export const GET_DOWNLOAD_PDF = "/client/survey-pdf/?survey_id={surveyId}";
export const GET_DOWNLOAD_CSV = "client/csv-report/?survey_id=";

export const GET_EMPLOYEE_LIST =
  "/admin/employee/?search={searchItem}&page={pageNumber}&page_size={pageSize}";
export const PATCH_RESET_EMPLOYEE_PASSWORD = "/admin/employee/reset_password/";

export const GET_EMPLOYEE_LIST_FOR_PLATFORM_ADMIN =
  "/admin/employee/?organization_id={orgId}&search={searchItem}&page={pageNumber}&page_size={pageSize}&survey_id={surveyId}";
export const PATCH_ACTIVATE_EMPLOYEE =
  "/admin/employee/activate/?organization_id={orgId}";
export const POST_CREATE_EMPLOYEE = "/admin/employee/";
export const PATCH_DELETE_EMPLOYEE =
  "/admin/employee/delete/?organization_id={orgId}";
export const PATCH_USER_DETAILS = "/admin/employee/";

export const POST_CHANGE_PASSWORD = "/change-password/";
export const ORGANISATION_PROFILE = "/client/organization/";
export const GET_STATES_DROPDOWN_DATA = "/client/master-data/?type=states";
export const GET_SECTORS_DROPDOWN_DATA = "/client/master-data/?type=sectors";
export const GET_EMPLOYEE_PROFORMANCE_SUMMARY =
  "/admin/performance-graph/?survey_id=";
export const GET_CRR_RESULTS = "/client/crr-results/?survey_id={surveyId}";
export const GET_ALL_SURVEYS = "/admin/all-survey/";
export const GET_MIL_MASTERDATA = "/client/master-data/?type=mils";
export const GET_SURVEY_STATUS = "/client/survey-status/";
export const GET_PROGRESS_GRAPH_DATA =
  "/client/crr-results/?survey_id=all&limit=3";
export const GET_DOMAINS_LIST = "/client/domains/?survey_id=";

//pre-assessments
export const PRE_ASSESSMENT_QUESTIONS = "/client/sections/";
export const PRE_ASSESSMENT_SECTIONS = "/client/list-sections/";
export const SUBMIT_PRE_ASSESSMENT = "/client/preassessment-ans-submission/";
export const GET_ORG_TYPES = "/client/master-data/?type=organization_types";
export const GET_PREASSESSMENT_CSV = "/client/csv/";

//control-librbary
export const LIBRARY_LIST = "/client/library/";
export const ADMIN_LIBRARY_LIST = "/admin/library/?organization_id=";

//state-admin role (Super Admin - portal)
export const POST_CREATE_STATE_ADMIN = "/admin/state_admin/";
export const PATCH_DELETE_STATE_ADMIN = "/admin/state_admin/delete/";
export const PATCH_STATE_ADMIN_DETAILS = "/admin/employee/";
export const GET_STATE_ADMIN_LIST =
  "/admin/state_admin/?search={searchItem}&page={pageNumber}&page_size={pageSize}";
export const PATCH_ACTIVATE_STATE_ADMIN = "/admin/state_admin/activate/";

//state-admin portal
export const GET_DOMAIN_MIL_GRAPH = "/admin/organizational-mil/";
export const GET_ORG_LIST = "/admin/organization/list/";
export const GET_ORG_MIL_GRAPH = "/admin/organizational-mil-for-domain/";
export const GET_ORG_DOMAIN_GRAPH =
  "/admin/organizational-completed-domain-count/";
export const GET_DOWNLOAD_STATE_ADMIN_CSV = "/admin/organizational-csv-report/";

//CSF survey
export const SECTIONS_API = "/client/list-sections/";
export const CATEGORIES_API = "/admin/categories/";
export const QUESTIONS_API = "/client/sections/";
export const CSF_ANSWER_SUBMIT_API = "/client/csf-ans-submission/";
export const AUDIT_TRAIL_API = "/admin/audit-trail/";
